var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('top-bar',{staticClass:"top-bar"}),_c('el-container',[_c('el-main',[_c('router-view'),_c('a',{style:(_vm._isMobile ? 'display:none':''),attrs:{"id":"TOPUp","href":"#app"}},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":require("@/assets/imgs/top.png"),"alt":""}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }